import { BreakpointsOptions } from '@mui/system';

export const breakpointsOptions: BreakpointsOptions = {
  step: 5,
  unit: 'px',
};
